
<div mat-dialog-title class="_pay-dialog-title">
  <span class="_cap">{{'EX_PAYMENT_MODAL' | translate}}</span>
  <button mat-icon-button mat-dialog-close cdkFocusInitial>
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>


<div mat-dialog-content>
  <block-ui>
    <iframe id="add_payment" name="add_payment" frameborder="0" scrolling="no" (load)="onFrameLoaded($event)"></iframe>
    <form id="send_token" action="" method="post" target="add_payment" style="display:none">
      CUST_NBR: <input type="text" name="CUST_NBR" value="{{args.CUST_NBR}}" />
      MERCH_NBR: <input type="text" name="MERCH_NBR" value="{{args.MERCH_NBR}}" />
      DBA_NBR: <input type="text" name="DBA_NBR" value="{{args.DBA_NBR}}" />
      TERMINAL_NBR: <input type="text" name="TERMINAL_NBR" value="{{args.TERMINAL_NBR}}" />
      BATCH_ID: <input type="text" name="BATCH_ID" value="{{args.BATCH_ID}}" />
      TRAN_NBR: <input type="text" name="TRAN_NBR" value="{{args.TRAN_NBR}}" />
      AMOUNT: <input type="text" name="AMOUNT" value="{{args.AMOUNT}}" />
      TAC: <input type="text" name="TAC" value="{{args.TAC}}" />
      TRAN_CODE: <input type="text" name="TRAN_CODE" value="{{'AUTH'}}" />
      <input type="text" name="REDIRECT_URL" value="https://us-bridge.tabit-int.com/finance/transaction-page" />
      <!--<input type="text" name="CUSTOM_CSS_URL" *ngIf="CUSTOM_CSS_URL" value="{{CUSTOM_CSS_URL}}" />-->
      @if (CUSTOM_JAVASCRIPT_URL) {
        <input type="text" name="CUSTOM_JAVASCRIPT_URL" value="{{CUSTOM_JAVASCRIPT_URL}}" />
      }

    </form>
  </block-ui>
</div>
